/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { HeaderDetectionResult } from "./HeaderDetectionResult";
export const DetectHeaderResponse = core.serialization.object({
    data: HeaderDetectionResult,
});
